module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=BM - Bermuda.58fd2d25.svg";